import 'magnific-popup';

$('.js-video-popup').magnificPopup({
  type: 'iframe',
  mainClass: 'mfp-full-scren-video',
  removalDelay: 160,
  preloader: false,
  fixedContentPos: false,
  disableOn: 300,
});
